export default {
  resultsLimit: 50,
  icons: {
    // Source: http://mapicons.nicolasmollet.com/
    url_base_out: "/wp-content/themes/rj-wp/images/map-icons/27A9E1",
    url_base_over: "/wp-content/themes/rj-wp/images/map-icons/652C90",
    url_base_infobox: "/wp-content/themes/rj-wp/images/map-icons/8CC63E",
    information: { over: "information.png", out: "information.png" },
    building: { over: "office-building.png", out: "office-building.png" },
    land: { over: "grass.png", out: "grass.png" },
    house: { over: "townhouse.png", out: "townhouse.png" },
    unit: { over: "apartment-3.png", out: "apartment-3.png" },
  },
};
